import React, { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Loans from "@/pages/Loans";
import Wealth from "@/pages/Wealth";
import Insurance from "@/pages/Insurance";
import CreditCard from "@/pages/CreditCard";
import DigitalMarketing from "@/pages/DigitalMarketing";
import ITServices from "@/pages/ITServices";
import InteriorDesign from "@/pages/InteriorDesign";
import Media from "@/pages/Media";
import Events from "@/pages/Events";
import Weddings from "@/pages/Weddings";
import Contact from "@/pages/Contact";
import AdminLeads from "@/pages/AdminLeads";
import NotFound from "@/pages/NotFound";

function ScrollAndLenis() {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf = requestAnimationFrame(function loop(t) {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function SiteShell({ children }) {
  return (
    <>
      <Navbar />
      <main className="min-h-screen">{children}</main>
      <Footer />
      <WhatsAppWidget />
    </>
  );
}

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white p-10 text-center">
          <p className="font-display text-2xl font-bold text-navy">Something went wrong.</p>
          <a href="/" className="btn-primary">Reload Evolve Elite</a>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <BrowserRouter>
      <ScrollAndLenis />
      <ErrorBoundary>
        <Routes>
          <Route path="/admin" element={<AdminLeads />} />
          <Route
            path="*"
            element={
              <SiteShell>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/loans" element={<Loans />} />
                  <Route path="/wealth" element={<Wealth />} />
                  <Route path="/insurance" element={<Insurance />} />
                  <Route path="/credit-card-liquidity" element={<CreditCard />} />
                  <Route path="/digital-marketing" element={<DigitalMarketing />} />
                  <Route path="/it-services" element={<ITServices />} />
                  <Route path="/interior-design" element={<InteriorDesign />} />
                  <Route path="/videography-photography" element={<Media />} />
                  <Route path="/event-management" element={<Events />} />
                  <Route path="/destination-weddings" element={<Weddings />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </SiteShell>
            }
          />
        </Routes>
      </ErrorBoundary>
      <Toaster position="top-center" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
